import React from "react";
import { Button } from "../utils/Button";
import { homepageData, categories } from "../Data/Homepage";
import { IoMdArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";
export const Homepage = () => {
  return (
    <div className="py-5 md:py-10 px-4 bg-white dark:bg-[#1C1C1C] dark:text-white lg:ml-20 lg:mr-20">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-center text-4xl">
          Discover user-friendly UX flows designed to tackle intricate use cases
          across diverse industries
        </h1>
        <p className="text-center w-3/4 hidden md:block lg:w-[90%] mx-auto py-2 text-xl">
          Your struggle to designing better user experiences ends here. We’re
          working constantly to update a library full of usable flows that solve
          users needs.
        </p>
      </div>
      <div className="w-fit mx-auto pt-4 ">
        <a href="/Pages/Plans">
          <button
            className={
              "bg-[#1C1C1C] py-[11px] px-4 rounded-lg  text-white dark:bg-white dark:!text-black"
            }
          >
            Unlock All Access
          </button>
        </a>
      </div>

      <div className="">
        {categories.map((cat) => (
          <div className="py-10">
            <div className="flex items-center justify-between">
              <div className="flex space-x-2">
                {/* <img
                  alt=""
                  src={cat.icon}
                  className="text-2xl mt-3 md:mt-2 w-6 h-6 md:w-7 md:h-7 dark:text-[#C7C7C7]"
                /> */}
                <div className="mt-3">{cat.icon}</div>
                <p className="text-[28px]">{cat.category}</p>
              </div>
              <a
                className="border-[1.5px] border-black dark:border-white px-4 py-2 flex items-center space-x-2 rounded-[8px]"
                href={`/Pages/AllFlows/${cat.category}`}
              >
                <p className="hidden md:block">View All</p>
                <IoMdArrowForward />
              </a>
            </div>

            <div className={`gap-5 ${cat.styles} py-6`}>
              {cat.cards.map((card, index) => (
                <div>
                  <Link  to="/Pages/ProductPage/" state={{card}}>
                    <div className="w-full h-60 bg-gray-400 rounded-2xl">
                      <img
                        className="w-full h-full object-cover rounded-2xl"
                        src={card.picture}
                        alt=""
                      />
                    </div>
                    <div className="flex justify-between sapce-x-4 items-center">
                      <p className="py-[10.5px] text-xl font-[500]">
                        {card.header}
                      </p>
                      <p className="bg-[#1C1C1C] text-white dark dark:bg-white dark:text-black  px-2 py-1 rounded-lg w-fit">
                        {card.price}
                      </p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <img
                        src={card.user.picture}
                        className="w-6 h-6 rounded-full"
                        alt=""
                      />
                      <p className="">By {card.user.name}</p>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* <div className="py-4 grid md:grid-cols-2 lg:grid-cols-3 gap-4 ">
        {homepageData.map((data) => (
          <div className="w-full">
            <div className="relative rounded-xl w-full h-80 bg-gray-400"></div>
            <div className="flex justify-between py-2">
              <div className="">
                <h1 className="text-2xl py-1">{data.title}</h1>
                <p className="font-[200]">{data.description}</p>
              </div>
              <a href={`/Pages/AllFlows/${data.title}`}>
              <IoMdArrowForward className="px-3 text-5xl h-8 border-2 border-black dark:border-white rounded-lg" />
              </a>
            </div>
          </div>
        ))}
      </div> */}

      <div className="bg-[#1C1C1C] dark:bg-white dark:text-black mt-4 px-8 text-white rounded-3xl max-w-7xl w-full lg:mx-auto mb-10 lg:px-40 py-6">
        <p className=" lg:w-12/16 max-w-2xl text-[28px]  mx-auto text-center">
          Want to see more? Unlock full-access now for an exclusive dive into
          better ux.
        </p>
        <div className="w-full md:w-fit mx-auto mt-4">
          <Button
            att={"bg-white w-full text-black dark:!bg-black dark:!text-white"}
            name="Unlock Now"
          />
        </div>
      </div>
    </div>
  );
};
